import { getDocTypeLangKey } from 'definitions/DocType';
import { i18ntrans, tc } from 'language/i18nkey';
import { OnOffTitle } from 'pages/dlcenter/leftpanel/comp/OnOffTitle';
import * as React from 'react';
import styled from 'styled-components';
import { DocTypeInfo, useZstdDlCenter } from '../useZstdDlCenter';
import { ChkInput } from './comp/ChkInput';
import { useMenuOpenClose } from './useMenuOpenClose';

type Props = {};

export const dlDocTypes: DocTypeInfo[] = [
  //{type: 'APPLICATION_NOTE', label: '', num: undefined},
  { type: 'CAD_DATA', label: '', num: undefined },
  { type: 'CATALOG', label: '', num: undefined },
  { type: 'CERTIFICATION', label: '', num: undefined },
  { type: 'DATASHEET', label: '', num: undefined },
  { type: 'EDUCATION_INTERNAL', label: '', num: undefined },
  { type: 'EDUCATION_NOTE', label: '', num: undefined },
  { type: 'EDUCATION_VIDEO', label: '', num: undefined },
  { type: 'MANUAL', label: '', num: undefined },
  { type: 'OS', label: '', num: undefined },
  //{type: 'SAMPLE', label: '', num: undefined},
  { type: 'SOFTWARE', label: '', num: undefined },
  { type: 'MARKETING_MATERIAL', label: '', num: undefined },
  //{ type: 'SW_SERVICE', label: '', num: undefined },
  //{type: 'TECH_GENERAL', label: '', num: undefined},
  //{type: 'TECHNICAL_GUIDE', label: '', num: undefined},
  //{type: 'TROUBLE_SHOOTING', label: '', num: undefined},
  //{type: 'USER_SAMPLE', label: '', num: undefined},
];

export const dlDocTypesArr = dlDocTypes.map((ele) => ele.type);

export const DocTypes = (props: Props) => {
  const { open, setOpen, selMenu } = useMenuOpenClose('docType');

  const { selDocTypes: sel, setSelDocTypes: setSel, docTypesCnt } = useZstdDlCenter();

  React.useEffect(() => {
    dlDocTypes.forEach((ele) => {
      const langKey = getDocTypeLangKey(ele.type);
      ele.label = i18ntrans.admin(langKey as any) || '';
    });
  }, []);

  // if (selMenu !== 'docType' && selMenu !== '') {
  //   return null;
  // }

  return (
    <Body>
      <Content>
        <OnOffTitle label={tc('i18n_type')} open={open} setOpen={setOpen} />
        {open && (
          <ContentBody>
            {dlDocTypes
              //.filter((ele) => !!docTypesCnt[ele.type])
              .map((ele) => (
                <ChkInput
                  key={ele.type}
                  label={ele.label}
                  num={docTypesCnt[ele.type]}
                  checked={!!sel[ele.type]}
                  setChecked={() => {
                    if (sel[ele.type]) {
                      let newSel = { ...sel };
                      delete newSel[ele.type];
                      setSel(newSel);
                    } else {
                      let newSel = { ...sel };
                      newSel[ele.type] = ele;
                      setSel(newSel);
                    }
                  }}
                  //num={ele.num}
                />
              ))}
          </ContentBody>
        )}
      </Content>
    </Body>
  );
};

const Body = styled.div`
  padding: 0 1.6rem;
`;

const Content = styled.div`
  padding: var(--title-padding-y) 0;
  border-bottom: 4px solid #eef1f6;
`;

const ContentBody = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 1.2rem;
`;
